import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export default () => {
  const { t } = useTranslation();

  return useMemo(
    () => [
      { label: t('skuNo'), key: 'skuNo' },
      { label: t('numberOfBins'), key: 'numberOfBins' },
      {
        label: t('StoreProductInventory.total'),
        key: 'totalProductQuantity',
      },
      {
        label: t('StoreProductInventory.availableToSell'),
        key: 'availableToSell',
      },
      {
        label: t('StoreProductInventory.notAvailableToSell'),
        key: 'notAvailableToSell',
      },
      {
        label: t('customerFacingReplenishment'),
        key: 'customerFacingReplenishment',
      },
      {
        label: t('availableInventoryElsewhere'),
        key: 'availableInventoryElsewhere',
      },
    ],
    [t],
  );
};
